import store from '@/store';

export function useCheckAuth() {
  const checkAuth = (
    { productTypeCode, productResourceIds, listDataCheckAuth, actionName },
    callback,
    errorCallback
  ) => {
    const param = {
      productTypeCode,
      actionName,
      productResourceIds,
      listDataCheckAuth
    };
    store
      .dispatch('authStore/checkProductResource', param)
      .then((data) => {
        callback(data);
      })
      .catch((err) => {
        errorCallback(err);
      });
  };

  return { checkAuth };
}
